import React from "react";
import { ArrowLeft } from "lucide-react";
import { BrandLogo } from "@/components/Brand";

export default function PrivacyPage({ settings, onBack }) {
  return (
    <div className="min-h-[100dvh] bg-[var(--fs-page)]">
      <div className="fs-container py-8">
        {onBack && (
          <button onClick={onBack} className="flex items-center gap-1.5 text-sm text-[var(--fs-ink-2)] mb-6 fs-focus rounded" data-testid="privacy-back-button">
            <ArrowLeft size={16} /> Indietro
          </button>
        )}
        <BrandLogo className="h-8" />
        <h1 className="text-2xl font-bold mt-5" data-testid="privacy-title">Informativa privacy</h1>
        <p className="text-sm text-[var(--fs-muted)] mt-1">FARMA.STORE Skin Analyzer</p>

        <div className="mt-6 fs-card p-6 space-y-4 text-sm text-[var(--fs-ink-2)] leading-relaxed">
          <p>{settings?.privacy_text || "Skin Analyzer utilizza temporaneamente le fotografie del volto al solo scopo di generare lo Skin Check richiesto."}</p>
          <div>
            <h2 className="font-semibold text-[var(--fs-ink)] mb-1">Cosa raccogliamo</h2>
            <p>Non richiediamo nome, cognome, telefono o email per ottenere il risultato. Ad ogni sessione è associato un identificativo anonimo.</p>
          </div>
          <div>
            <h2 className="font-semibold text-[var(--fs-ink)] mb-1">Le tue fotografie</h2>
            <p>Le immagini vengono elaborate in modo transitorio per l'analisi cosmetica visiva. L'applicazione non le archivia in un database permanente e non crea un archivio storico dei volti. Non vengono incluse automaticamente nel report né inviate su WhatsApp.</p>
          </div>
          <div>
            <h2 className="font-semibold text-[var(--fs-ink)] mb-1">Cosa non facciamo</h2>
            <p>Skin Analyzer non effettua riconoscimento dell'identità, non esegue identificazione biometrica e non fornisce diagnosi mediche. Il servizio non misura parametri fisiologici della pelle.</p>
          </div>
          <div>
            <h2 className="font-semibold text-[var(--fs-ink)] mb-1">Finalità</h2>
            <p>Il risultato è un profilo cosmetico visivo pensato per aiutarti, insieme al personale di {settings?.store_name || "Farma Store"}, a scegliere una routine adatta. Non sostituisce la valutazione di un medico o dermatologo.</p>
          </div>
        </div>

        <p className="mt-6 text-xs text-[var(--fs-muted)]">
          {settings?.report_footer || "Farma Store – Parafarmacia e Servizi · Via Casilina 193, Castrocielo (FR)"}
        </p>
      </div>
    </div>
  );
}
